const bilboards = [ 
    "https://ichef.bbci.co.uk/news/976/cpsprodpb/1BBE/production/_126620170_gettyimages-1239665326.jpg" , 
    'https://www.bmediagroup.com/news/wp-content/uploads/2020/12/how-much-does-a-billboard-cost-social.jpg' , 
    'https://graphicsfamily.com/wp-content/uploads/edd/2020/06/Free-Restaurant-Billboard-Advertising-Template-scaled.jpg' , 
    'https://civicoutdoor.com.au/wp-content/uploads/Untitled-design-28.png' ,
    "https://i.ytimg.com/vi/kVwLQh4LRWw/maxresdefault.jpg"
]

export default bilboards;